import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDivElement> {
  static targets = ['goToOkButton']

  declare readonly goToOkButtonTarget: HTMLButtonElement

  goToNumberChanged(e: InputEvent): void {
    this.goToOkButtonTarget.classList.remove('hidden')
    const input = e.target as HTMLInputElement
    if (input.value === '') {
      this.goToOkButtonTarget.classList.add('hidden')
    }
  }
}
